import { BeDocument } from '@/types/chat';
import { Image } from 'antd';
import { DocumentText } from 'iconsax-react';

type Props = {
  files?: BeDocument[];
};

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];

const isImageFile = (file: BeDocument): boolean => {
  let ext = file.extension?.toLowerCase();
  if (!ext && file.name) {
    ext = file.name.split('.').pop()?.toLowerCase() as string;
  }
  if (!ext && file.blobFileUrl) {
    const urlWithoutQuery = file.blobFileUrl.split('?')[0];
    ext = urlWithoutQuery.split('.').pop()?.toLowerCase() as string;
  }
  if (file.type && file.type.toLowerCase().startsWith('image/')) return true;
  return ext ? IMAGE_EXTENSIONS.includes(ext) : false;
};

const MessageFiles = ({ files }: Props) => {
  if (!files || files.length === 0) return null;

  return (
    <div
      className="flex flex-wrap gap-2 text-primary"
      data-testid="chat-message-files"
    >
      <Image.PreviewGroup>
        {files.map((file) => {
          const isImage = isImageFile(file);

          if (isImage) {
            return (
              <div
                key={file.id}
                className="w-14 h-14 sm:w-20 sm:h-20 rounded-2xl overflow-hidden border border-input-border/30 bg-surface-secondary flex items-center justify-center shadow-sm hover:opacity-90 transition-opacity flex-shrink-0"
                data-testid="chat-message-file-item"
              >
                <Image
                  alt={file.name || 'file image'}
                  src={file.blobFileUrl}
                  width="100%"
                  height="100%"
                  className="object-cover w-full h-full"
                />
              </div>
            );
          }

          const fileExt =
            file.extension || file.name?.split('.').pop() || 'file';

          return (
            <a
              key={file.id}
              href={file.blobFileUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl border border-input-border/30 bg-surface-secondary flex flex-col items-center justify-center p-2 gap-1 shadow-sm hover:bg-surface-primary transition-colors text-primary no-underline group flex-shrink-0"
              title={file.name}
              data-testid="chat-message-file-item"
            >
              <DocumentText
                size={24}
                className="text-primary group-hover:scale-110 transition-transform"
              />
              <span className="text-[10px] uppercase font-semibold text-secondary truncate max-w-full px-1">
                {fileExt}
              </span>
            </a>
          );
        })}
      </Image.PreviewGroup>
    </div>
  );
};

export default MessageFiles;
